import { AppConstants } from "./core/common/Constants";
import AppLayout from "./core/ui/layouts/AppLayout";
import BaseLayout from "./core/ui/layouts/BaseLayout";
import RootLayout from "./core/ui/layouts/RootLayout";
import TLayoutMap from "./core/ui/layouts/TLayoutMap";
import PortalLayout from "./portal/ui/layouts/PortalLayout";

export interface TApplicationConfig {
  areas: string[];
  layouts: TLayoutMap;
}

export interface TApplication {
  name: string;
  configuration: TApplicationConfig;
}

let areas = {
  registry: [
    "home",
    "authentication",
    "codebook",
    "caseLawDocuments",
    "indexType",
    "organisationIndexData",
    "search",
    "caseDecisions",
    "organisation",
    "organisationCaseDecisionTypes",
    "attachmentType",
    "report",
    "legalView",
    "organisationLegalViewTypes"
  ],

  portal: ["portal", "search", "codebook", "organisation"]
};

let layouts = {
  registry: {
    appLayout: AppLayout,
    baseLayout: BaseLayout,
    rootLayout: RootLayout
  },

  portal: {
    appLayout: PortalLayout,
    baseLayout: BaseLayout,
    rootLayout: RootLayout
  }
};

export default class ApplicationConfig {
  private application: TApplication;

  constructor(name: string) {
    this.application = this.configureApplication(name);
  }

  public getApplicationName() {
    return this.application.name;
  }

  private configureApplication(applicationName: string): TApplication {
    if (!Object.values(AppConstants).includes(applicationName)) {
      throw new Error("No application named " + applicationName);
    }

    let application: TApplication;

    application = {
      name: applicationName,
      configuration: {
        areas: areas[applicationName],
        layouts: layouts[applicationName]
      }
    };

    return application;
  }

  public get areas(): string[] {
    return this.application.configuration.areas;
  }

  public get layouts(): TLayoutMap {
    return this.application.configuration.layouts;
  }
}
